import { useAtomValue } from 'jotai';
import { useNumFormatter } from '~/utils/format/num-formatter';
import { useTranslation } from 'react-i18next';
import { $CurrentHashtagInfoAsAvailable } from '~/routes/topic.$hashtag_id/shared/atoms';

import './style.scss';

export default function HashtagDescriptionSection(): JSX.Element {
  const { t } = useTranslation();
  const hashtag = useAtomValue($CurrentHashtagInfoAsAvailable);
  const { description, name, views_count } = hashtag;
  const formatNum = useNumFormatter();
  const viewsCount = formatNum(views_count);

  return (
    <section id="hashtag-description-section">
      <h1>{`#${name}`}</h1>
      <span>{t('view_count_plural', { num: viewsCount }).replace('%d', viewsCount)}</span>
      {description.trim() && <p>{description}</p>}
    </section>
  );
}
